import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  customTransformedTreeData: [],
  customSelectedTreeIds: [],
  customFinalTreeData: [],
  customAutocomplete: [],
  customBottlerData: [],
  customFilterApplied: false,
  customManageForecastTreeData: [],
  customManageForecastBottlerData: [],
  customManageForecastFinalTreeData: [],
  customShortTermPeriodList: [],
  customLongTermPeriodList: []
};

const customEntitySlice = createSlice({
  name: "customEntity",
  initialState,
  reducers: {
    setCustomTransformedTreeData: (state, action) => {
      state.customTransformedTreeData = action.payload;
    },
    setCustomSelectedTreeIds: (state, action) => {
      state.customSelectedTreeIds = action.payload;
    },
    setCustomFinalTreeData: (state, action) => {
      state.customFinalTreeData = action.payload;
    },
    setCustomAutocomplete: (state, action) => {
      state.customAutocomplete = action.payload;
    },
    setCustomBottlerData: (state, action) => {
      state.customBottlerData = action.payload;
    },
    setCustomFilterApplied: (state, action) => {
      state.customFilterApplied = action.payload;
    },
    setCustomManageForecastTreeData: (state, action) => {
      state.customManageForecastTreeData = action.payload;
    },
    setCustomManageForecastBottlerData: (state, action) => {
      state.customManageForecastBottlerData = action.payload;
    },
    setCustomManageForecastFinalTreeData: (state, action) => {
      state.customManageForecastFinalTreeData = action.payload;
    },
    setCustomStPeriodList: (state, action) => {
      state.customShortTermPeriodList = action.payload;
    },
    setCustomLtPeriodList: (state, action) => {
      state.customLongTermPeriodList = action.payload;
    }
  },
});

export const {
  setCustomTransformedTreeData,
  setCustomSelectedTreeIds,
  setCustomFinalTreeData,
  setCustomAutocomplete,
  setCustomBottlerData,
  setCustomFilterApplied,
  setCustomManageForecastTreeData,
  setCustomManageForecastBottlerData,
  setCustomManageForecastFinalTreeData,
  setCustomStPeriodList,
  setCustomLtPeriodList
} = customEntitySlice.actions;

export default customEntitySlice.reducer;